import { Card, Tag } from 'antd';
import { CalendarOutlined, EyeOutlined } from '@ant-design/icons';
import s from './index.module.css';
import { DEFAULT_CASE_COVER } from '../../config/constants';
import {formatDate} from "../../utils/videoHelpers";
import {modules} from "../ServiceModules";

const CaseCard = ({ caseData, onClick }) => {
  const { id, title, coverImageUrl, categoryId, createTime, viewCount, description } = caseData;

  const findType = modules.find(t => t.code === categoryId);

  return (
    <Card
      className={s.caseCard}
      hoverable
      cover={
        <div className={s.caseImageWrapper}>
          <img
            alt={title}
            src={coverImageUrl || DEFAULT_CASE_COVER}
            className={s.caseImage}
            onError={(e) => {
              e.target.src = DEFAULT_CASE_COVER;
            }}
          />
          <div className={s.caseCategoryTag}>
            <Tag color="blue">{findType?.smallTitle}</Tag>
          </div>
        </div>
      }
      bodyStyle={{ padding: '16px' }}
      onClick={() => onClick && onClick(caseData)}
    >
      <div className={s.caseContent}>
        <h4 className={s.caseTitle}>{title}</h4>

        <div className={s.caseMeta}>
          <div className={s.metaItem}>
            <CalendarOutlined className={s.metaIcon} />
            <span className={s.metaText}>{formatDate(createTime)}</span>
          </div>
          <div className={s.metaItem}>
            <EyeOutlined className={s.metaIcon} />
            <span className={s.metaText}>{viewCount}</span>
          </div>
        </div>

        <p className={s.caseDescription}>{description}</p>
      </div>
    </Card>
  );
};

export default CaseCard;
